(function (Drupal, drupalSettings) {
  Drupal.behaviors.front = {};
  Drupal.behaviors.front.attach = (context: HTMLElement) => {
    const selectors = [
      // System path matches.
      `[data-mnair-link-system-path="${CSS.escape(drupalSettings.path.currentPath as string)}"]`,
    ];

    // Find URL matches.
    const segments = window.location.pathname.split('/').filter(segment => segment !== '');
    let currentPath = '';
    for (const segment of segments) {
      currentPath += '/' + segment;
      selectors.push(`[href="${CSS.escape(currentPath)}"]`);
    }

    // Query the DOM.
    const activeLinks = context.querySelectorAll(selectors.join(','));
    const il = activeLinks.length;
    for (let i = 0; i < il; i++) {
      activeLinks[i].classList.add('is-active');
      activeLinks[i].setAttribute('aria-current', 'page');
    }
  };
})(Drupal, drupalSettings);

export {};
